import { render, staticRenderFns } from "./ExpertSettingsIcon.vue?vue&type=template&id=c4100d40&scoped=true"
import script from "./ExpertSettingsIcon.vue?vue&type=script&lang=js"
export * from "./ExpertSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4100d40",
  null
  
)

export default component.exports